import OfferInclusionItem from 'components/Common/Inclusions/OfferInclusionItem'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import FlashHotelReturnFlightsInclusion from 'components/OfferPage/FlashHotel/FlashHotelReturnFlightsInclusion'
import OfferPagePackageInclusionsList from 'components/OfferPage/OfferPagePackageInclusionsList'
import Group from 'components/utils/Group'
import LoyaltyInclusions from 'loyalty/components/LoyaltyInclusions'
import LuxPlusInclusions from 'luxPlus/components/LuxPlusInclusions'

export interface PropertyRateInclusionListsProps {
  property: App.Property.Property
  inclusions: Array<App.OfferInclusion>
  bonusInclusions: Array<App.OfferInclusion>
  luxPlusInclusions: Array<App.OfferInclusion>
  bundleInclusions: Array<App.OfferInclusion>
}

interface Props extends PropertyRateInclusionListsProps {
  /**
   * Bundled return flights belong to the booking rather than to any one rate, so the caller reads
   * them from the offer page state and passes them in rather than each rate resolving its own.
   */
  showReturnFlightsInclusion?: boolean
  rooms?: Array<App.Occupants>
}

function PropertyRateInclusionsStack({
  property,
  inclusions,
  bonusInclusions,
  luxPlusInclusions,
  bundleInclusions,
  showReturnFlightsInclusion,
  rooms,
}: Props) {
  return <VerticalSpacer gap={12}>
    {!!luxPlusInclusions.length && <LuxPlusInclusions
      luxPlusInclusions={luxPlusInclusions}
      accommodationOffer={property}
    />}
    {!!bonusInclusions.length && <OfferPagePackageInclusionsList variant="bonus">
      {bonusInclusions.map(inclusion => <OfferInclusionItem key={inclusion.id} inclusion={inclusion} />)}
    </OfferPagePackageInclusionsList>}
    <Group direction="vertical" gap={4} noDisplayWhenEmpty>
      {!!bundleInclusions.length && <VerticalSpacer gap={4}>
        {bundleInclusions.map(inclusion => <OfferInclusionItem key={inclusion.id} inclusion={inclusion} isHighlighted colour="exclusive" />)}
      </VerticalSpacer>}
      {(showReturnFlightsInclusion || !!inclusions.length) && <VerticalSpacer gap={4}>
        {showReturnFlightsInclusion && <FlashHotelReturnFlightsInclusion rooms={rooms ?? []} />}
        {inclusions.map(inclusion => <OfferInclusionItem key={inclusion.id} inclusion={inclusion} />)}
      </VerticalSpacer>}
      <LoyaltyInclusions offer={property} variant="offer-page" />
    </Group>
  </VerticalSpacer>
}

export default PropertyRateInclusionsStack
